var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { staticClass: "mt-1", attrs: { cols: "12" } }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal.modal-addcategory",
                    modifiers: { "modal-addcategory": true },
                  },
                ],
                staticClass: "my-1",
                attrs: { variant: "primary" },
              },
              [_vm._v(" Add Category ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "2" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: { label: "Per Page:", "label-for": "per-page-select" },
            },
            [
              _c("b-form-select", {
                attrs: {
                  id: "per-page-select",
                  options: _vm.pageOptions,
                  size: "sm",
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: {
                variant: "outline-danger",
                size: "sm",
                disabled: !_vm.filter,
              },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-addcategory",
            "cancel-variant": "outline-secondary",
            centered: "",
            title: "Add Category",
            "hide-footer": "",
          },
          on: { hidden: _vm.resetAddCategoryData },
        },
        [
          _c("validation-observer", {
            ref: "categoryFormAdd",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "b-form",
                      {
                        ref: "addCategory",
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.AddCategory($event)
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "Name" } }, [
                              _vm._v("Category Name*"),
                            ]),
                            _c("validation-provider", {
                              attrs: {
                                rules: "required",
                                name: "Category",
                                vid: "Category",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            placeholder: "Category Name",
                                          },
                                          model: {
                                            value: _vm.addCategoryData.name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.addCategoryData,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression: "addCategoryData.name",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button", block: "" },
                              on: { click: _vm.AddCategory },
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", {
                                    staticClass: "mx-2",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                              _vm._v("Add "),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-editcategory",
            "cancel-variant": "outline-secondary",
            centered: "",
            title: "Edit Category",
            "hide-footer": "",
          },
          on: { hidden: _vm.resetEditCategory },
        },
        [
          _c("validation-observer", {
            ref: "categoryFormEdit",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.saveUpdatedCategory($event)
                          },
                        },
                      },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c("label", { attrs: { for: "editName" } }, [
                              _vm._v("Category Name*"),
                            ]),
                            _c("validation-provider", {
                              attrs: { rules: "required", name: "Category" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "editName",
                                            type: "text",
                                            placeholder: "Enter Category Name",
                                          },
                                          model: {
                                            value: _vm.editCategoryData.name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editCategoryData,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression: "editCategoryData.name",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "modal-footer" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary", block: "" },
                                on: { click: _vm.saveUpdatedCategory },
                              },
                              [
                                _vm.loading
                                  ? _c("b-spinner", {
                                      staticClass: "mx-2",
                                      attrs: { small: "" },
                                    })
                                  : _vm._e(),
                                _vm._v(" Update "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              items: _vm.filteredCategories,
              fields: _vm.fields,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "head(name)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Category Name")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Category Name",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.filter,
                            callback: function ($$v) {
                              _vm.filter = $$v
                            },
                            expression: "filter",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "toggle-class": "text-decoration-none",
                          "no-caret": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "text-body align-middle mr-25",
                                    attrs: {
                                      icon: "MoreVerticalIcon",
                                      size: "16",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.viewCategory(data.item.id)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "EyeIcon" },
                            }),
                            _c("span", [_vm._v("View")]),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.updateSubcategory(data.item)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "EditIcon" },
                            }),
                            _c("span", [_vm._v("Edit")]),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.removeitemCategory(data.item.id)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "TrashIcon" },
                            }),
                            _c("span", [_vm._v("Delete")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.categoryList.length === 0
                ? _c(
                    "b-alert",
                    {
                      staticClass: "d-flex justify-content-center",
                      attrs: { variant: "warning", show: "" },
                    },
                    [
                      _c("h4", { staticClass: "alert-heading" }, [
                        _vm._v("No categories yet, please add"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.errorCall
                ? _c(
                    "b-alert",
                    {
                      staticClass: "d-flex justify-content-center",
                      attrs: { variant: "danger", show: "" },
                    },
                    [
                      _c("h4", { staticClass: "alert-heading" }, [
                        _vm._v(
                          " An Error has occured, please try again later "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loading
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
          _c("b-form-group", [
            _vm._v(
              " Showing " +
                _vm._s(
                  _vm.totalRows > 0
                    ? _vm.perPage * (_vm.currentPage - 1) + 1
                    : 0
                ) +
                " to " +
                _vm._s(
                  _vm.totalRows > 0
                    ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                    : 0
                ) +
                " of " +
                _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                " entries "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }